import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subsection } from 'src/app/models/obs/subsection';
import { Log } from 'src/app/models/user-log';
import { SectionService } from 'src/app/services/obs/section.service';
import { SubsectionService } from 'src/app/services/obs/subsection.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UserLogService } from 'src/app/services/user-log.service';
import { UtilLogService } from 'src/app/services/util/util-log.service';

@Component({
  selector: 'app-admsubsection-form',
  templateUrl: './admsubsection-form.component.html',
  styleUrl: './admsubsection-form.component.scss'
})
export class AdmsubsectionFormComponent implements OnInit {

  form: FormGroup;
  sub: Subsection = null;

  edit: boolean = false;
  idsectionSelected: number = null;
  linkString: string = '<a href="url_destino" target="_blank">texto_a_enlazar</a>';

  isSectionBlocked: boolean = false;

  constructor(
    private t3Service: Tier3Service,
    private router: Router,
    private subS: SubsectionService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private utilLogservice: UtilLogService,
    private tokenStorage: TokenStorageService,
    private sectionService: SectionService
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.createForm();
    this.getSubsection(params);
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      idsection: [null],
      ideditor: [null],
      order: ['', Validators.required],
      title: [],
      content: [],
      touchedBy: [''],
      status: []
    })
  }

  getIsBlockedSection(id: number) {
    this.t3Service.idSectionblocked(id).subscribe({
      next: res => {
        this.isSectionBlocked = res['isBlocked'];
      },
      error: err => { console.log(err); }
    })
  }

  getSubsection(params: any) {
    if (params.id) {
      this.subS.getOne(params.id).subscribe({
        next: res => {
          this.sub = res['data'];
          this.idsectionSelected = this.sub.idsection;
          this.getIsBlockedSection(this.idsectionSelected);
          this.loadData();
          this.edit = true;
        },
        error: err => console.error(err)
      });
    } else if (params.idsection) {
      this.idsectionSelected = params.idsection;
      this.getIsBlockedSection(this.idsectionSelected);
      this.edit = false;
    }
  }

  loadData() {
    this.form.reset(this.sub);
  }

  cancel() {
    this.router.navigate(['/adm/subseccion/list/', this.idsectionSelected]);
  }

  save() {
    if (this.form.invalid) {
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
    }
  }

  dataLog = {};
  tempID = {}
  create(sub: Subsection) {
    delete sub.id;
    sub.idsection = +this.idsectionSelected;
    sub.touchedBy = this.tokenStorage.getUser().nombre;
    //artifio para evitar Uncaught SyntaxError: Unexpected token 4 in JSON at position 0
    this.tempID['id'] = this.activedRoute.snapshot.params['idsection']
    const tempid = this.tempID
    //artifico end

    this.sectionService.getIdTier3(tempid).subscribe({
      next: res => {
        this.dataLog['idtier3'] = res['data'].idtier3;//determinamos el tier3
        if (res) {
          this.subS.create(sub).subscribe({
            next: res => {
              // Crear el log de actividad del usuario
              if (res) this.utilLogservice.createLog(res['data'], 'creación', 'subseccion');
              this.goBackList();
            },
            error: err => console.error(err)
          })
        }
      },
      error: err => console.error('estamos recibiendo error', err)
    });
  }

  update(id: string, sub: Subsection) {
    const data = { ...sub };
    delete sub.id;
    sub.touchedBy = this.tokenStorage.getUser().nombre;
    this.subS.update(id, sub).subscribe({
      next: res => {

        //artifio para evitar Uncaught SyntaxError: Unexpected token 4 in JSON at position 0
        this.tempID['id'] = sub.idsection
        const tempid = this.tempID
        //artifico end
        this.sectionService.getIdTier3(tempid).subscribe({
          next: res => {
            // Crear el log de actividad del usuario
            if (res) this.utilLogservice.createLog(data, 'edición', 'subseccion');
            this.goBackList();
          },
          error: err => console.error('Error', err)
        });
        console.log("res update: ")
      },
      error: err => console.error(err)
    });

  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }

  goBackList() {
    this.router.navigate(['/adm/subseccion/list', this.idsectionSelected]);
  }

}
